//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { has } from "lodash";
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
import * as StoryAiConfigActions from './actions';
import axios from "axios"
import { apis } from 'utils/lib/apis';
import configInfo from "config"
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List Widgets ----------------
export const handleListStoryAiConfig = (data, is_student) => async (dispatch) => {
    try {
        const path = is_student ? '/list_soy_story_student' : '/listStoryAiConfig';
        const body_data = is_student ? { chapter: data.chapter, class_id: data.class_id } : { chapter: data.chapter, user_id: data.user_id }
        const soyStoryData = await apis.post('storyAiConfigRDS', path, {
            body: body_data
        });
        if(soyStoryData&&soyStoryData.success){
            await dispatch(StoryAiConfigActions.listStoryWithAi(soyStoryData.data));
        }
      
        return soyStoryData;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing story ai config',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'LIST_STORY_AI_CONFIG'
            });
        }
    }
};

//  -- Delete Widgets ----------
export const handleDeleteStoryAiConfig = (id) => async (dispatch) => {
    if (!id) return;
    // dispatch(StoryAiConfigActions.deleteWidgets())
    try {
        const deleteWidgets = await apis.del('storyAiConfigRDS', `/deleteStoryAiConfig/${id}`);
        if (has(deleteWidgets, "id")) {
            await dispatch(StoryAiConfigActions.deleteStoryWithAi(deleteWidgets));
        }
        return deleteWidgets;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting story ai config',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'DELETE_STORY_AI_CONFIG'
            });
        }
    }
};
export const handleShareSoyStoryToStudent = (id, activate_for_student) => async (dispatch) => {
    if (!id) return;
    try {
        const updatedStatus = await apis.post('storyAiConfigRDS', `/share_to_student`, {
            body: { activate_for_student, id }
        });
        if (updatedStatus && updatedStatus.success) {
            await dispatch(StoryAiConfigActions.updateStoryWithAi(updatedStatus.data));
        }
        return updatedStatus;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'sharing soy story to student',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'SET_STUDENT_STUDENT_TEACHER_STUDENT'
            });
        }
    }
};
export const handleShareSoyStoryToTeacher = (data) => async (dispatch) => {
    if (!data||!data.id) return;
    try {
        const updatedStatus = await apis.post('storyAiConfigRDS', `/share_to_teacher`, {
            body: data
        });
        if (updatedStatus && updatedStatus.success) {
            const { updated_data  } = updatedStatus.data || {};
            await dispatch(StoryAiConfigActions.updateStoryWithAi(updated_data||{}));
        }
        return updatedStatus.data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'sharing soy story to teacher',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'SET_STUDENT_STUDENT_TEACHER_TIPS'
            });
        }
    }
};

export const handleUpdateStoryAiConfig = (data,key_to_update) => async (dispatch) => {
    if (!data || !data.id) return;
    try {
        const updatedStory = await apis.put('storyAiConfigRDS', '/updateStoryAiConfig', {
            body: { ...data, key_to_update }
        });
        const responseData = updatedStory?.data || updatedStory || {};
        const payload = {
            ...responseData,
            id: responseData?.id || data?.id,
            story_content: responseData?.story_content || data?.story_content || data?.content?.story_content
        };
        if (payload?.id) {
            await dispatch(StoryAiConfigActions.updateStoryWithAi(payload));
        }
        return updatedStory;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating story ai config',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'UPDATE_STORY_AI_CONFIG'
            });
        }
        return {};
    }
};



//  -- get list story by id ----------
export const handleListStoryById = (id) => async (dispatch) => {
    if (!id) return;
    try {
        const listStoryById = await apis.get('storyAiConfigRDS', `/listStoryById/${id}`);
        // if (has(listStoryById, "id")) {
        //     await dispatch(StoryAiConfigActions.deleteStoryWithAi(listStoryById));
        // }
        return listStoryById;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing story by id',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'LIST_STUDENT_BOOK_INSTRUCTION'
            });
        }
    }
};

export const handleAddOrUpdateOneStory = (data) => async (dispatch) => {
    dispatch(StoryAiConfigActions.addOrUpdateAiStory(data));
};

//article_levels

export const handleListChapterArticle = ({chapter}) => async (dispatch) => {
    try {
        const data = await apis.post('storyAiConfigRDS', '/articles_levels/list_by_chapter', {
            body: {
                chapter
            }
        });
        if(data&&data.success){
            await dispatch(StoryAiConfigActions.listArticleLevel(data.data));
        }
      
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing chapter article',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'LIST_CLASS_ACTIVITY'
            });
        }
    }
};


export const handleUpdateArticleLevel = (data) => async (dispatch) => {
    try {
        const update_data = await apis.post('storyAiConfigRDS', '/articles_levels/update', {
            body: data
        });
        if(update_data&&update_data.success){
            await dispatch(StoryAiConfigActions.updateArtitclelevel(update_data.data));
        }
        return update_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating article level',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'UPDATE_ACTIVITY_LESSON'
            });
        }
        return {}
    }
}
export const generateImageWithPrompt = async(data) => {
    try {
        const image_data = await apis.post('storyAiConfigRDS', '/articles_levels/ai_image', {
            body: data
        });
        return image_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'generating image with prompt',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'GET_INSTRUCTION_WORKSHEET_PREFERENCE'
            });
        }
        return {}
    }
}

export const updateArticleText = async(data) => {
    try {
        const image_data = await apis.post('storyAiConfigRDS', '/articles_levels/update_text', {
            body: data
        });
        return image_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating article text',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'UPDATE_ACTIVITY_TEACHER'
            });
        }
        return {}
    }
}

export const handleDeleteArticleLevel = (id) => async (dispatch) => {
    try {
        const delete_data = await apis.del('storyAiConfigRDS', `/articles_levels/delete/${id}`);
        if(delete_data&&delete_data.success){
            await dispatch(StoryAiConfigActions.deleteArticleLevel({id}));
        }
        return delete_data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting article level',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'DELETE_ACTIVITY_LESSON'
            });
        }
    }
}

export const handleGetArticleByid = async (id)  => {
    if (!id) return;
    try {
        const listStoryById = await apis.get('storyAiConfigRDS', `/articles_levels/by_id/${id}`);
        return listStoryById;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting article by id',
                error,
                module: 'STORY_AI_CONFIG',
                operation: 'GET_ACTIVITY_BOOK_INSTRUCTION'
            });
        }
        return {}
    }
};

export const handleAddOrUpdateArticleLevel = (data) => async (dispatch) => {
    dispatch(StoryAiConfigActions.addOrUpdateArticleLevel(data));
};

export const handleGetStoryMediaStatus = (id) => async (dispatch) => {
    if (!id) return;
    try {
        const storyMediaStatus = await apis.get('vocabularyRDS', `/ai_story_media_status/${id}`);
        return storyMediaStatus;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting story media status',
                error,
                module: 'VOCABULARY',
                operation: 'GET_STORY_MEDIA_STATUS'
            });
        }
        return {
            is_audio_generated: false,
            is_image_generated: false,
            imageUrls: null,
            status: 'error'
        }
    }
}

export const handleRegenerateStory = (data) => async (dispatch) => {
    if (!data||!data.storyId) return;
    try {
        const regenerateStory = await apis.post('vocabularyRDS', `/regenerate_story_media_status`, {
            body: data
        });
        return regenerateStory;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'regenerating story',
                error,
                module: 'VOCABULARY',
                operation: 'REGENERATE_STORY'
            });
        }
        return {}
    }
}

export const handleGenerateStoryMedia = ({ story_id, generate_image = true }) => async () => {
    if (!story_id) return;
    try {
        const response = await apis.post('vocabularyRDS', `/storeMediaForStory`, {
            body: {
                story_id,
                generate_image
            }
        });
        return response;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'generating story media',
                error,
                module: 'VOCABULARY',
                operation: 'GENERATE_STORY_MEDIA'
            });
        }
        return {};
    }
}

export const handleRequestStoryMedia = ({ story_id, generate_image = true }) => async () => {
    if (!story_id) return;
    try {
        await apis.post('vocabularyRDS', `/request_media`, {
            body: {
                method: "POST",
                function_name: "vocabularyRDS-prod-storeMediaForStory",
                body: {
                    story_id,
                    generate_image,
                }
            }
        });
        return true;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'requesting story media generation',
                error,
                module: 'VOCABULARY',
                operation: 'REQUEST_STORY_MEDIA_GENERATION'
            });
        }
        return {};
    }
}